// src/HomePage/Game/FolkGame/Caro/CaroWaitingRoom.js
import React, { useEffect, useState } from 'react';
import { ROOM_TIMEOUT_MS, deleteFolkRoom } from '../FolkGameService';
import './CaroWaitingRoom.css';

const CaroWaitingRoom = ({ room, currentUser, onToggleReady, onKickPlayer, onLeave }) => {
  const [inactivityWarning, setInactivityWarning] = useState(null);

  const getPlayerName = (player) => {
    if (!player) return '';
    const holy = player.holyName ? `${player.holyName} ` : '';
    const full = player.fullName || player.name || 'Người chơi';
    return `${holy}${full}`.trim();
  };

  const isHost = room.player1?.id === currentUser?.id;
  const myReadyStatus = isHost ? room.player1?.ready : room.player2?.ready;

  // Watchdog kiểm tra không hoạt động trong 10 phút
  useEffect(() => {
    const checkInterval = setInterval(async () => {
      const lastActive = room.lastActivityAt || room.createdAt || Date.now();
      const elapsed = Date.now() - lastActive;
      const remainingMs = ROOM_TIMEOUT_MS - elapsed;

      // Còn dưới 2 phút (120 giây) -> Hiện cảnh báo
      if (remainingMs <= 2 * 60 * 1000 && remainingMs > 0) {
        const mins = Math.ceil(remainingMs / 60000);
        setInactivityWarning(`⚠️ Bàn chơi sẽ tự hủy sau khoảng ${mins} phút nữa nếu không có ai tương tác.`);
      } else if (remainingMs <= 0) {
        // Hết 10 phút -> Xóa bàn & rời phòng
        clearInterval(checkInterval);
        if (isHost) {
          await deleteFolkRoom('caro', room.id);
        }
        alert('⏱️ Bàn chơi đã tự đóng do không có hoạt động trong 10 phút!');
        onLeave();
      } else {
        setInactivityWarning(null);
      }
    }, 5000);

    return () => clearInterval(checkInterval);
  }, [room.lastActivityAt, room.createdAt, room.id, isHost, onLeave]);

  const handleKick = () => {
    if (window.confirm(`Bạn có chắc muốn mời ${getPlayerName(room.player2)} ra khỏi bàn?`)) {
      onKickPlayer();
    }
  };

  return (
    <div className="caro-wait-wrapper">
      <div className="caro-wait-header">
        <button className="caro-wait-leave-btn" onClick={onLeave}>
          {isHost && !room.player2 ? '⬅️ Hủy Bàn' : '⬅️ Rời Bàn'}
        </button>
        <div className="caro-wait-title-box">
          <h3>{room.name}</h3>
          <span className="caro-wait-status-tag">⏳ Chờ sẵn sàng</span>
        </div>
      </div>

      {inactivityWarning && (
        <div className="caro-inactivity-alert">
          {inactivityWarning}
        </div>
      )}

      <div className="caro-wait-card">
        {/* Player 1 (Host) */}
        <div className={`caro-wait-player ${room.player1?.ready ? 'is-ready' : ''}`}>
          <div className="caro-wait-avatar">{room.player1?.avatar || '🎓'}</div>
          <span className="caro-wait-name">{getPlayerName(room.player1)}</span>
          <span className="caro-wait-role">Chủ Bàn (X)</span>
          <span className={`caro-wait-pill ${room.player1?.ready ? 'ready' : 'not-ready'}`}>
            {room.player1?.ready ? '✅ ĐÃ SẴN SÀNG' : '⏳ CHƯA SẴN SÀNG'}
          </span>
        </div>

        <div className="caro-wait-vs">VS</div>

        {/* Player 2 */}
        <div className={`caro-wait-player ${room.player2?.ready ? 'is-ready' : ''}`}>
          <div className="caro-wait-avatar">
            {room.player2 ? (room.player2.avatar || '🎓') : '⏳'}
          </div>
          <span className="caro-wait-name">
            {room.player2 ? getPlayerName(room.player2) : 'Đang đợi đối thủ vào...'}
          </span>
          <span className="caro-wait-role">{room.player2 ? 'Đối Thủ (O)' : 'Vị trí trống'}</span>

          {room.player2 && (
            <span className={`caro-wait-pill ${room.player2?.ready ? 'ready' : 'not-ready'}`}>
              {room.player2?.ready ? '✅ ĐÃ SẴN SÀNG' : '⏳ CHƯA SẴN SÀNG'}
            </span>
          )}

          {isHost && room.player2 && (
            <button
              type="button"
              className="caro-wait-kick-btn"
              onClick={handleKick}
              title="Mời người này ra khỏi bàn"
            >
              Mời ra 🚫
            </button>
          )}
        </div>
      </div>

      <div className="caro-wait-action-area">
        <button
          type="button"
          className={`caro-wait-ready-btn ${myReadyStatus ? 'active' : ''}`}
          onClick={onToggleReady}
          disabled={!room.player2}
        >
          {!room.player2
            ? 'Đang chờ đối thủ vào phòng...'
            : myReadyStatus
            ? '✕ Hủy Sẵn Sàng'
            : '✔️ Bấm Sẵn Sàng'}
        </button>
      </div>
    </div>
  );
};

export default CaroWaitingRoom;